export default {
  id: 144,
  title: 'Target #144 - Long Heart',
  url: 'https://cssbattle.dev/play/144',
  colors: ['#62306D', '#F7EC7D'],
  solution:
    '<a a><a b><a c><style>[a],[b]{left:0;background:#f7ec7d}[c],body{background:#62306d}a{position:fixed}[a]{bottom:0;width:165;height:165}[b]{top:100;width:75;height:75;border-radius:9in;box-shadow:125px 125px #f7ec7d}[c]{top:125;left:75;width:100;height:100;border-radius:0 25px}</style>',
}
